import {LitElement, html} from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

export class PreOrderButton extends LitElement {
  dateMessage() {
    const arrival_date = this.date
    const is_in_future = moment(this.date).subtract(2, 'days').isAfter()
    const display_message = document.createElement('span')
    this.appendChild(display_message)
    const parsed_date = moment(this.date).format("MMM Do YY");
    const card = document.querySelector('.collection-grid-section')
    const message_intro = this.isDescendant(card, this) ? 'Delivery ' : 'Stocks available for delivery '
    const message_text = `${message_intro} from ${parsed_date}`
    
    display_message.classList.add('product-inventory__alert--custom')
    const message = is_in_future ? display_message : `` 
    display_message.innerText = message_text
    
    
  }
  isDescendant(parent, child) {
    let node = child.parentNode;
    while (node) {
        if (node === parent) {
            return true;
        }

        // Traverse up to the parent
        node = node.parentNode;
    }

    // Go up until the root but couldn't find the `parent`
    return false;
};

  render() {
    return html`
      ${this.dateMessage()}
      <slot></slot>
    `;
  }
    static get properties() {
    return {
      date: {type: String},
    };
  }
}
  window.customElements.define('pre-order-button', PreOrderButton);